import { FC } from 'react';

import { isEmpty } from 'lodash/fp';

import _ from '../../locale';
import { getAiChatFeedbackCategoryLocaleKey } from '../../models/ai-chat-feedback';
import { styled } from '../../theme';
import { AiChatFeedbackDetails } from '../../types';
import { hasFeedbackDetails } from '../../utility/ai-chat-content';
import FlexColumn from '../FlexColumn';
import FlexRow from '../FlexRow';
import { BubbleMessageText, Chip } from './styles';

const FeedbackContent = styled(FlexColumn)({
    gap: 12,
    width: '100%',
});

const FeedbackCategoriesRow = styled(FlexRow)({
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    gap: 8,
    width: '100%',
});

export interface FeedbackMessageProps {
    feedback: AiChatFeedbackDetails;
}

const FeedbackMessage: FC<FeedbackMessageProps> = ({ feedback }) => {
    const { reaction, comment, categories } = feedback;

    if (!hasFeedbackDetails(feedback)) {
        return null;
    }

    return (
        <FeedbackContent>
            {!isEmpty(categories) && (
                <FeedbackCategoriesRow>
                    {categories.map((category) => (
                        <Chip key={category} feedbackReaction={reaction ?? null}>
                            {_(getAiChatFeedbackCategoryLocaleKey(category))}
                        </Chip>
                    ))}
                </FeedbackCategoriesRow>
            )}
            {comment && <BubbleMessageText>{comment}</BubbleMessageText>}
        </FeedbackContent>
    );
};

export default FeedbackMessage;
